import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ac865e9a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac865e9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac865e9a')) {
      api.createRecord('ac865e9a', component.options)
    } else {
      api.reload('ac865e9a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ac865e9a&scoped=true&", function () {
      api.rerender('ac865e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Jagty6meKdP/JS/comp/Accordion.vue"
export default component.exports